// extracted by mini-css-extract-plugin
export default {"share-button-container":"Upjdl","share-button":"HKKFa","email":"ymrmP"};